
export * from './modal-tag-promo-point.module'
export * from './modal-tag-promo-point.component'
